import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useFetch } from "@/components/common";
import { api, errMsg } from "@/lib/api";

export function ConfirmDialog({ title, children, onConfirm, onClose, label = "Supprimer", testid = "confirm-dialog", wide, primary }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    await onConfirm();
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className={wide ? "max-w-xl" : "max-w-md"} data-testid={testid}>
        <DialogHeader><DialogTitle className="font-display text-[#0E2D43]">{title}</DialogTitle></DialogHeader>
        <div className="text-sm text-slate-600 space-y-3">{children}</div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid={`${testid}-cancel`}>Annuler</Button>
          <Button onClick={go} disabled={busy} className={primary ? "bg-[#F49619] hover:bg-[#E0830B] text-[#0E2D43] font-bold" : "bg-rose-600 hover:bg-rose-700 text-white"} data-testid={`${testid}-confirm`}>
            {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}{label}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

function CleanupDialog({ onClose, onDone }) {
  const { data } = useFetch("/demo/history/summary");
  const total = (data || []).reduce((s, r) => s + r.demo, 0);
  const run = async () => {
    try {
      await api.delete("/demo/history", { params: { confirm: "NETTOYER" } });
      toast.success(`${total} enregistrement(s) de démonstration supprimé(s)`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <ConfirmDialog title="Nettoyer les données de démonstration" onConfirm={run} onClose={onClose} label={`Supprimer ${total} enregistrement(s)`} testid="demo-cleanup-dialog" wide>
      <p>Seuls les enregistrements marqués DÉMO seront supprimés définitivement. Aucun véhicule, chauffeur, compte ou donnée réelle Prest'hyg n'est touché.</p>
      <div className="overflow-x-auto"><table className="tbl w-full" data-testid="demo-cleanup-summary">
        <thead><tr><th>Données</th><th className="text-right">À supprimer</th><th className="text-right">Réelles conservées</th></tr></thead>
        <tbody>{(data || []).map((r) => (
          <tr key={r.collection} data-testid={`demo-cleanup-row-${r.collection}`}><td>{r.label}</td><td className="text-right tabular-nums font-bold text-rose-700">{r.demo}</td><td className="text-right tabular-nums">{r.real}</td></tr>
        ))}</tbody>
      </table></div>
    </ConfirmDialog>
  );
}

export function DemoCleanupButton({ onDone }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} className="border-rose-300 text-rose-700 hover:bg-rose-50" data-testid="demo-cleanup-button">
        <Trash2 className="w-4 h-4 mr-1" /> Nettoyer les données de démonstration
      </Button>
      {open && <CleanupDialog onClose={() => setOpen(false)} onDone={() => { setOpen(false); onDone?.(); }} />}
    </>
  );
}
